import { 
  Flex,
  View,
  Text,
  Heading,
  Button,
  Card,
  Grid
} from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

const LandingPage = ({ toggleAuth }) => {

  const handleGetStarted = () => {
    // Call toggleAuth with true to indicate sign-up mode
    toggleAuth(true);
  };

  return (
    <View style={{ position: 'relative', overflow: 'hidden' }}>
      {/* Full page animated background */}
      <View
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          zIndex: -1
        }}
      >
        {/* Animated bubbles covering entire background */}
        <View
          style={{
            position: 'absolute',
            top: '-100px',
            left: '-100px',
            width: '300px',
            height: '300px',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.1)',
            animation: 'float 6s ease-in-out infinite'
          }}
        />
        <View
          style={{
            position: 'absolute',
            bottom: '-150px',
            right: '-150px',
            width: '400px',
            height: '400px',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.08)',
            animation: 'float 8s ease-in-out infinite reverse'
          }}
        />
        <View
          style={{
            position: 'absolute',
            top: '40%',
            left: '10%',
            width: '250px',
            height: '250px',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.06)',
            animation: 'float 10s ease-in-out infinite'
          }}
        />
        <View
          style={{
            position: 'absolute',
            bottom: '30%',
            right: '20%',
            width: '350px',
            height: '350px',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.07)',
            animation: 'float 12s ease-in-out infinite reverse'
          }}
        />
        <View
          style={{
            position: 'absolute',
            top: '60%',
            right: '40%',
            width: '200px',
            height: '200px',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.09)',
            animation: 'float 15s ease-in-out infinite'
          }}
        />
      </View>

      {/* Hero Section - now transparent to show background */}
      <Flex 
        direction="column" 
        justifyContent="center" 
        alignItems="center"
        padding="4rem 1rem 1rem 1rem"
        width="100%"
        style={{
          position: 'relative',
          minHeight: '500px'
        }}
      >
        {/* Hero content box - Updated to dark theme */}
        <View
          style={{
            background: 'rgba(30, 35, 45, 0.85)',
            backdropFilter: 'blur(20px)',
            borderRadius: '20px',
            padding: '3rem 2rem',
            border: '1px solid rgba(255,255,255,0.1)',
            boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
            maxWidth: '900px',
            width: '100%'
          }}
        >
        
        <Flex
          direction="column"
          justifyContent="center"
          alignItems="center"
          width="100%"
          gap="2rem"
          position="relative"
          zIndex="1"
        >
          <View textAlign="center">
            <Heading 
              level={1} 
              textAlign="center"
              fontSize="3.5rem"
              style={{ 
                color: 'white',
                marginBottom: '1rem',
                lineHeight: '1.2'
              }}
            >
              AI-Powered Internship Platform
            </Heading>
            
            <Text
              textAlign="center"
              fontSize="1.4rem"
              style={{ 
                color: 'rgba(255,255,255,0.9)',
                lineHeight: '1.6',
                maxWidth: '600px',
                margin: '0 auto'
              }}
            >
              Find your perfect internship with intelligent CV feedback 
              and personalised job matching
            </Text>
          </View>

          <Flex justifyContent="center">
            <Button
              variation="primary"
              size="large"
              onClick={handleGetStarted}
              style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                border: 'none',
                borderRadius: '30px',
                padding: '1rem 2.5rem',
                fontSize: '1.2rem',
                fontWeight: '600',
                color: 'white',
                transition: 'all 0.3s',
                boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.3)';
              }}
            >
              Get Started
            </Button>
          </Flex>
        </Flex>
        </View>
      </Flex>

      {/* How It Works Section - now transparent to show background */}
      <View
        style={{
          position: 'relative',
          width: '100%'
        }}
      >
        <Flex
          direction="column"
          justifyContent="center"
          alignItems="center"
          padding="0 1rem 5rem 1rem"
          width="100%"
          style={{
            position: 'relative',
            backgroundColor: 'transparent',
            minHeight: '600px'
          }}
        >
          
          <View textAlign="center" marginBottom="4rem" position="relative" zIndex="2">
            <Text 
              fontSize="1rem" 
              color="rgba(255,255,255,0.9)"
              fontWeight="bold"
              textTransform="uppercase"
              letterSpacing="0.1em"
              marginBottom="0.5rem"
            >
              Simple Process
            </Text>
            <Heading 
              level={2} 
              textAlign="center"
              fontSize="2.5rem"
              style={{ color: 'white' }}
            >
              How It Works
            </Heading>
          </View>

          <Grid
            templateColumns={{base: '1fr', medium: 'repeat(3, 1fr)'}}
            gap="2rem"
            width="100%"
            maxWidth="1200px"
            position="relative"
            zIndex="2"
          >
          {/* Step 1 - Upload CV */}
          <Card
            borderRadius="16px"
            padding="2.5rem"
            style={{
              background: 'rgba(30, 35, 45, 0.85)',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(255,255,255,0.1)',
              boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
              transition: 'all 0.3s',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-10px)';
              e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.3)';
            }}
          >
            <View
              style={{
                position: 'absolute',
                top: '0',
                left: '0',
                right: '0',
                height: '5px',
                background: 'linear-gradient(90deg, #ffd700 0%, #ff6b6b 100%)',
                boxShadow: '0 2px 10px rgba(255, 215, 0, 0.5)'
              }}
            />
            <Flex direction="column" alignItems="center" gap="1.5rem">
              <View
                width="90px"
                height="90px"
                borderRadius="50%"
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  boxShadow: '0 5px 20px rgba(102, 126, 234, 0.3)'
                }}
              >
                <Text color="white" fontSize="2.5rem">📄</Text>
              </View>
              <Heading level={4} textAlign="center" fontSize="1.5rem" style={{ color: 'white' }}>
                Upload Your CV
              </Heading>
              <Text textAlign="center" color="rgba(255,255,255,0.7)" lineHeight="1.6">
                Get instant AI-powered feedback and improvement tips to optimise your CV
              </Text>
            </Flex>
          </Card>

          {/* Step 2 - Search & Browse */}
          <Card
            borderRadius="16px"
            padding="2.5rem"
            style={{
              background: 'rgba(30, 35, 45, 0.85)',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(255,255,255,0.1)',
              boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
              transition: 'all 0.3s',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-10px)';
              e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.3)';
            }}
          >
            <View
              style={{
                position: 'absolute',
                top: '0',
                left: '0',
                right: '0',
                height: '5px',
                background: 'linear-gradient(90deg, #00d2ff 0%, #3a7bd5 100%)',
                boxShadow: '0 2px 10px rgba(0, 210, 255, 0.5)'
              }}
            />
            <Flex direction="column" alignItems="center" gap="1.5rem">
              <View
                width="90px"
                height="90px"
                borderRadius="50%"
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  boxShadow: '0 5px 20px rgba(102, 126, 234, 0.3)'
                }}
              >
                <Text color="white" fontSize="2.5rem">🔍</Text>
              </View>
              <Heading level={4} textAlign="center" fontSize="1.5rem" style={{ color: 'white' }}>
                Search & Discover
              </Heading>
              <Text textAlign="center" color="rgba(255,255,255,0.7)" lineHeight="1.6">
                Filter opportunities by location, field, and interests from multiple platforms
              </Text>
            </Flex>
          </Card>

          {/* Step 3 - Check & Apply */}
          <Card
            borderRadius="16px"
            padding="2.5rem"
            style={{
              background: 'rgba(30, 35, 45, 0.85)',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(255,255,255,0.1)',
              boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
              transition: 'all 0.3s',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-10px)';
              e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.3)';
            }}
          >
            <View
              style={{
                position: 'absolute',
                top: '0',
                left: '0',
                right: '0',
                height: '5px',
                background: 'linear-gradient(90deg, #f857a6 0%, #ff5858 100%)',
                boxShadow: '0 2px 10px rgba(248, 87, 166, 0.5)'
              }}
            />
            <Flex direction="column" alignItems="center" gap="1.5rem">
              <View
                width="90px"
                height="90px"
                borderRadius="50%"
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  boxShadow: '0 5px 20px rgba(102, 126, 234, 0.3)'
                }}
              >
                <Text color="white" fontSize="2.5rem">🎯</Text>
              </View>
              <Heading level={4} textAlign="center" fontSize="1.5rem" style={{ color: 'white' }}>
                Check & Apply
              </Heading>
              <Text textAlign="center" color="rgba(255,255,255,0.7)" lineHeight="1.6">
                Get CV compatibility analysis, then apply directly on the original platform
              </Text>
            </Flex>
          </Card>
        </Grid>
        </Flex>
      </View>

      <style jsx>{`
        @keyframes float {
          0% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-30px);
          }
          100% {
            transform: translateY(0px);
          }
        }
      `}</style>
    </View>
  );
};

export default LandingPage;